export default __webpack_public_path__ + "static/media/Dr-Kusuma-M-R.d53d1419.jpg";